import React from 'react';
import { IAuditoriaPejotizacaoResultado } from '../interfaces/IAuditoriaPejotizacao';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaPejotizacaoResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Governança e Detecção de Pejotização — recorrência mensal consecutiva em pagamentos a
// fornecedores de Serviços Prestados por Terceiros, confirmada via QSA (sócio/administrador) da
// própria empresa auditada. Fundamentação: CPC 00 (Essência sobre a Forma) / CLT, Art. 3º.
const AuditoriaResumoPejotizacao: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = (resultado.fornecedoresRecorrentes || []).length;
  const totalSocios = (resultado.fornecedoresRecorrentes || []).filter((item) => item.ehSocio).length;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Governança e Detecção de Pejotização</h3>
      <p className='text-muted'>
        Fornecedores de Serviços Prestados por Terceiros com pagamentos recorrentes por 3 ou mais meses
        consecutivos exigem due diligence trabalhista (CLT, Art. 3º). Quando o fornecedor corresponde a um
        sócio/administrador da própria empresa (QSA), confirma-se o risco de pejotização (CPC 00 — Essência
        sobre a Forma). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Risco Fiscal / Valor Recorrente</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_PEJOTIZACAO')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Governança e Detecção de Pejotização</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} fornecedor{totalOcorrencias === 1 ? '' : 'es'} recorrente{totalOcorrencias === 1 ? '' : 's'} no período, {totalSocios} confirmado{totalSocios === 1 ? '' : 's'} como sócio (QSA)</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Valor pago a fornecedores recorrentes: {formatCurrency(resultado.impactoFinanceiroTotal)}</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoPejotizacao;
